import { RowCustomAction } from '@msdk/common'
import { OptionsetValue, StringValue } from '@msdk/definitions'

export class SyncMsLangAction extends RowCustomAction {
  async onClick(): Promise<void> {
    await this.handleClick()
  }

  handleClick = async () => {
    const msName = (this.row.fields['OWNER'] as StringValue)?.value
    const langCode = (this.row.fields['CODE'] as OptionsetValue)?.value

    await this.apiClient.read(`${msName}/api/translation/RetryImport/${langCode}`)

    this.reload()
  }

  isDisabled(): boolean {
    return false
  }

  isVisible(): boolean {
    return true
  }
}
